import { Box } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../../actions/product_builder';
import cloud from '../../img/cloud.jpg';
import { isPremiumOption } from '../../utils/isPremium';
import layout from '../../styles/layout.module.css';
import typography from '../../styles/typography.module.css';
import { useTranslation } from 'react-i18next';
export const CustomArtwork = ({ width, isDisabled }) => {
    const env = process.env;
    const price = parseFloat(env.REACT_APP_ARTWORK_PRICE).toFixed(2).toString();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const faceplate = useSelector((state) => state.rootReducer.currentFaceplateOption);
    const currentSide = useSelector((state) => state.rootReducer.settingsOptions.currentSide);
    const { getRootProps, getInputProps } = useDropzone({
        maxSize: 10_000_000,
        maxFiles: 2,
        accept: {
            'image/jpeg': ['.jpeg', '.png']
        },
        onDrop: (acceptedFiles) => {
            const url = URL.createObjectURL(acceptedFiles[0]);
            const artwork = generateArtworkObject(url);
            if (currentSide === 'both') {
                if (
                    !isPremiumOption(faceplate.leftOption) &&
                    !isPremiumOption(faceplate.rightOption)
                ) {
                    dispatch(allActions.artworkActions.setActiveArtwork(artwork));
                    dispatch(allActions.priceActions.setBothArtworkPrice(artwork));
                }
            } else if (currentSide === 'left') {
                dispatch(allActions.artworkActions.setLeftArtwork(artwork));
                dispatch(allActions.priceActions.setLeftArtworkPrice(artwork));
            } else {
                dispatch(allActions.artworkActions.setRightArtwork(artwork));
                dispatch(allActions.priceActions.setRightArtworkPrice(artwork));
            }
        }
    });

    const generateArtworkObject = (url) => {
        return {
            sku: 'Custom Artwork',
            displayName: 'Custom Artwork',
            price: price,
            leftImage: url,
            rightImage: url
        };
    };

    if (width < 800) {
        return (
            <Box className={`${layout.excerptContainer} ${isDisabled ? 'is-disabled' : ''}`}>
                <div
                    {...getRootProps({
                        className: `dropzone ${layout.customArtworkContainer}`
                    })}>
                    <input {...getInputProps()} />
                    <p
                        style={{
                            textAlign: 'center',
                            color: '#000000',
                            fontSize: 'regular',
                            fontFamily: 'Montserrat'
                        }}>
                        Tap to upload
                    </p>
                    <p className={typography.artworkDisclaimer}>{t('artwork.custom_disclaimer')}</p>
                </div>
            </Box>
        );
    }
    return (
        <Box className={`${layout.excerptContainer} ${isDisabled ? 'is-disabled' : ''}`}>
            <div
                {...getRootProps({
                    className: `dropzone ${layout.customArtworkContainer}`
                })}>
                <input {...getInputProps()} />
                <div className={layout.costumArtworkInnerSection}>
                    <img className={typography.cloudIcon} alt="cloud" src={cloud} />
                    <p className={typography.dragAndDropText}>{t('artwork.drag_and_drop')}</p>
                    <p className={typography.artworkDisclaimer}>{t('artwork.custom_disclaimer')}</p>
                </div>
            </div>
            <div></div>
        </Box>
    );
};
